import { FeatureFlag } from "src/store/api/generatedApi";

export const OPERATIONS_FEATURE_FLAG: FeatureFlag = "operations";
